<template>
  <form-edit-activity :form-type="FORM_TYPE" ref="formEditor"
                      :mode="mode"
                      :entity-id="entityId"
                      @form-created="formCreated"
  >
  </form-edit-activity>
</template>

<script>

import Activity from "@/activity/Activity";
import PermissionsSet from "@/server/PermissionsSet";
import Rpc from "@/Rpc";
import FormsListActivity from "@/activity/templates/layouts/forms/FormsListActivity";
import FormsLoader from "@/components/forms/FormsLoader";

import FormEditActivity from "@/activity/templates/layouts/forms/FormEditActivity";
import FormMixin from "@/components/forms/customizations/mixins/FormMixin";
import ReachInput from "@/components/inputs/ReachInput";
import Tranche from "@/server/com/silkplm/model/plm/Tranche";
import StatusIntegrationLogger from "@/server/com/silkplm/model/plm/dictionaries/StatusIntegrationLogger";


const FORM_TYPE = Tranche;

export default {
  name: "TrancheEditor",
  components: {ReachInput, FormMixin, FormEditActivity, FormsListActivity},
  permission: () => FormsLoader.formPermission(FORM_TYPE),

  props: {
    entityId: {default: null},
    orderId: {default: null},
    orderClass: {default: null},
    orderDetailsId: {default: null},
    orderDetailsClass: {default: null},
    mode: {type: String, default: "NEW"},
  },

  async created() {
    if (this.mode === "NEW") {
      this.orderInstance = await Rpc.Forms.getEntity(this.orderClass, this.orderId);
      this.orderDetailsInstance = await Rpc.Forms.getEntity(this.orderDetailsClass, this.orderDetailsId);
      this.form.fields.orderId.value = this.orderInstance.id;
    }
  },

  mounted(){
  },

  methods: {
    ...Activity.methods,

    /** @type {FormModel} form */
    async formCreated(form) {
      this.form = form;
    },

    async canClose() {
      return this.$refs.formEditor.canClose();
    },

    getTitle() {
      if (this.mode === "NEW") {
        return $tr('new','New ') + this.formConfig.entityName;
      } else {
        return this.$refs.formEditor?.title;
      }
    },

  },

  data: function () {
    return {
      FORM_TYPE,
      /** @type {FormModel} */
      form: null,
      readOnly: true,
      permissions: new PermissionsSet(),
      formConfig: FormsLoader.detectFormConfig(FORM_TYPE),
      formId: FormsLoader.detectFormConfig(FORM_TYPE).formId,
      orderInstance: null,
    }
  }
}
</script>
